// extracted by mini-css-extract-plugin
export default {"slide":"AnalyticsExportPresentation_slide__vqIx1","active":"AnalyticsExportPresentation_active__8+Jn2","past":"AnalyticsExportPresentation_past__cBIWk"};